export default __webpack_public_path__ + "static/hiiotcase2-edf0bc80812fff6f32cc9fe3cffae0fc.png";